import { useLoggedInUser } from "Hooks/useLoggedInUser";
import type { Amount } from "Infrastructure/Api/Api";
import { REGION_TO_MARKET_CURRENCY } from "Utils/CurrencyUtils";

/**
 * Returns a builder that wraps a number as an Amount payload denominated in the
 * user's market currency (CZ -> CZK, SK -> EUR).
 *
 * Throws for a region-less context: money payloads must never fall back to a
 * guessed currency, and every payment flow sits behind the region gate.
 */
export const useAmount = () => {
  const user = useLoggedInUser();
  const region = user?.region;

  return (value: number): Amount => {
    if (!region) {
      throw new Error(
        "Cannot build an Amount payload without the user's market region.",
      );
    }

    return { value, currencyCode: REGION_TO_MARKET_CURRENCY[region] };
  };
};
